import "moment-timezone";
import React, { Component } from "react";
import { Modal } from 'react-bootstrap';
import NotPresentedForm from './NotPresentedForm';

class NotPresentedModal extends Component {
  render() {
    const { deal, showModal, onConfirmModal, onCloseModal } = this.props

    return (
      <Modal show={showModal} onHide={onCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Trial Coaching Session was Not Presented</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <NotPresentedForm deal={deal} onCancelSubmit={onCloseModal} onSubmit={onConfirmModal} />
        </Modal.Body>
      </Modal>)
  }
}

export default NotPresentedModal